<template>
  <FlexColumn :space="0">
    <TextButton :small="small" accent @click="handleClick">検索条件の保存</TextButton>
    <ApplicantSearchConditionsSaveDialog
        :open="confirm"
        :andKeyword="andKeyword"
        :orKeyword="orKeyword"
        :data="data"
        :dataType="dataType"
        :currentPrefectures="currentPrefectures"
        :prefectures="prefectures"
        :positions="positions"
        :salaryLower="salary.lower"
        :salaryUpper="salary.upper"
        :gender="gender"
        :ageLower="age.lower"
        :ageUpper="age.upper"
        :medalist="medalist"
        :newcomer="newcomer"
        :scoutable="scoutable"
        @close="handleClose"
    />
  </FlexColumn>
</template>

<script>
import TextButton from "@/components/atoms/TextButton";
import FlexColumn from "@/components/atoms/FlexColumn";
import ApplicantSearchConditionsSaveDialog from "@/components/organisms/ApplicantSearchConditionsSaveDialog";
export default {
  name: "ApplicantSearchConditionsSaveButton",
  components: {ApplicantSearchConditionsSaveDialog, FlexColumn, TextButton},
  props: {
    andKeyword: {
      type: String
    },
    orKeyword: {
      type: String
    },
    data: {
      type: Array
    },
    dataType: {
      type: String
    },
    currentPrefectures: {
      type: Array,
    },
    prefectures: {
      type: Array,
    },
    positions: {
      type: Array
    },
    salary: {
      type: Object,
      default: () => ({})
    },
    gender: {
      type: Number
    },
    age: {
      type: Object,
      default: () => ({})
    },
    medalist: {
      type: Boolean
    },
    newcomer: {
      type: Boolean
    },
    scoutable: {
      type: Boolean
    },
    small: {
      type: Boolean
    }
  },
  data() {
    return {
      confirm: false,
    }
  },
  methods: {
    handleClick() {
      this.confirm = true
    },
    handleClose() {
      this.confirm = false
    },
  }
}
</script>

<style scoped>

</style>